import React from 'react'
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <div>
          <section className="wed-hom-footer">
        <div className="container">
            <div className="row foot-supp">
                <h2><span>Free support:</span> +91 75989 84380 &nbsp;&nbsp;|&nbsp;&nbsp; <span>Email:</span>
                    info@example.com</h2>
            </div>
            <div className="row wed-foot-link wed-foot-link-1">
                <div className="col-md-4">
                    <h4>Get In Touch</h4>
                    <p>Address: Kanyakumari district is headquartered in Koothanvilai village under Palapallam panchayat. Registration No. 38/IV.</p>
                    <p>Phone: <a href="tel:+917904462944">+91 75989 84380</a></p>
                    <p>Email: <a href="mailto:info@example.com">info@example.com</a></p>
                </div>
                <div className="col-md-4">
                    <h4>HELP &amp; SUPPORT</h4>
                    <ul>
                        
                        <li><Link to='/AboutUs'>About company</Link>
                        </li>
                        <li><Link to='/Contactus'>Contact us</Link>
                        </li>
                        <li><Link to='/PrivacyPolicy'>Privacy Policy</Link>
                        </li>
                        <li><Link to='/RefundPolicy'>Refund Policy</Link>
                        </li>
                        <li><a href="about-us.html#testimonials">Testimonials</a>
                        </li>
                    </ul>
                </div>
                <div className="col-md-4 fot-soc">
                    <h4>SOCIAL MEDIA</h4>
                <ul>
  <li>
    <a href="#!">
      <img src="images/social/1.png" alt="" loading="lazy" />
    </a>
  </li>
  <li>
    <a href="#!">
      <img src="images/social/2.png" alt="" loading="lazy" />
    </a>
  </li>
  <li>
    <a href="#!">
      <img src="images/social/3.png" alt="" loading="lazy" />
    </a>
  </li>
  <li>
    <a href="#!">
      <img src="images/social/5.png" alt="" loading="lazy" />
    </a>
  </li>
</ul>

                </div>
            </div>
            <div className="row foot-count">
                <p>Company name Site - Trusted by over thousands of Boys & Girls for successfull marriage. <a
                        href="sign-up.html" className="btn btn-primary btn-sm">Join us today !</a></p>
            </div>
        </div>
    </section>
    {/* <!-- END --> */}

    {/* <!-- COPYRIGHTS --> */}
    <section>
        <div className="cr">
            <div className="container">
                <div className="row">
                    <p>Copyright © <span id="cry">2023</span> <a href="#!" target="_blank">Company.com</a> All
                        rights reserved.</p>
                </div>
            </div>
        </div>
    </section>
      
    </div>
  )
}

export default Footer
